import React from "react";
import { Doughnut, Bar } from "react-chartjs-2";
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
} from "chart.js";
import { LEVEL_ADMIN } from "../../../utils/userPermissions";
import { usePermissions } from "../../../context/permissionsContext";

const COLORS = ["#b3e1f8", "#023047", "#ffb703", "#fb5800"];

// Register ChartJS elements
ChartJS.register(
  ArcElement,
  BarElement,
  ChartTooltip,
  Legend,
  CategoryScale,
  LinearScale,
  Title
);

function Graphs({ graphData }) {
  const { hasPermission } = usePermissions();

  const pieData = [
    {
      name: "Withdrawals",
      value: Number(graphData?.charts?.pie_chart?.total_withdrawal) || 0,
    },
    {
      name: "Balance",
      value: Number(graphData?.charts?.pie_chart?.total_balance) || 0,
    },
    {
      name: "In Process",
      value: Number(graphData?.charts?.pie_chart?.total_in_process) || 0,
    },
  ];

  const filteredPieData = pieData
    .map((item, index) => ({ ...item, color: COLORS[index] }))
    .filter((item) => item.value > 0);

  const hasNoPieData = filteredPieData.length === 0;

  const barChartDataRaw =
    graphData?.charts?.bar_chart?.map((entry) => ({
      time: entry.date,
      usersJoined: entry.value,
    })) || [];

  const hasNoBarData = barChartDataRaw.length === 0;

  const donutData = {
    labels: pieData.map((item) => item.name),
    datasets: [
      {
        data: pieData.map((item) => item.value),
        backgroundColor: COLORS,
        borderWidth: 1,
      },
    ],
  };

  const donutOptions = {
    plugins: {
      legend: {
        position: "bottom",
      },
    },
    cutout: "60%",
  };

  const barChartData = {
    labels: barChartDataRaw.map((item) => item.time),
    datasets: [
      {
        label: "Users Joined",
        data: barChartDataRaw.map((item) => item.usersJoined),
        backgroundColor: "#B3E1F8",
        borderRadius: 4,
      },
    ],
  };

  const barOptions = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function (context) {
            return `Users Joined: ${context.parsed.y}`;
          },
        },
      },
    },
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          precision: 0,
        },
        grid: {
          display: false, // Hide horizontal grid lines
          drawBorder: false, // Optional: hides the axis border
        },
      },
    },
  };

  return (
    <>
      <div className="col-lg-6 col-12 px-0 pr-lg-4 pr-0 mb-lg-0 mb-3">
        <div className="card mb-0">
          <div className="card-body px-0">
            <div className="d-space-between">
              <div className="mb-auto">
                <h3 className="pl-4 d-start">
                  {hasPermission(LEVEL_ADMIN) ? "Payments" : "Earnings ($)"}
                </h3>
              </div>
            </div>
            {!hasNoPieData ? (
              <div
                className="d-center"
                style={{ width: "100%", height: "290px" }}
              >
                <Doughnut data={donutData} options={donutOptions} />
              </div>
            ) : (
              <div className="d-center mh-100 h-auto">
                <span>No data</span>
              </div>
            )}
          </div>
        </div>
      </div>

      <div className="col-lg-6 col-12 px-0 h-auto">
        <div className="card mb-3">
          <div className="card-body px-0">
            <h3 style={{ marginBottom: 13 }} className="pl-4">
              Users
            </h3>
            {!hasNoBarData ? (
              <div className="px-3 bar-chart-wrapper">
                <Bar
                  data={barChartData}
                  options={barOptions}
                  height={300}
                  width={470}
                />
              </div>
            ) : (
              <div className="d-center mh-100 h-auto">
                <span>No data</span>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Graphs;
